$(function() {
    $(document).on('click', '.navbar-burger', function () {
        var target = $(this).attr('data-target');

        if ($(this).hasClass('is-active')) {
            $(this).removeClass('is-active');
            $('#' + target).removeClass('is-active');
        } else {
            $(this).addClass('is-active');
            $('#' + target).addClass('is-active');
        }
    });

    $(document).on('click', '.navbar-item.has-dropdown', function () {
        var $target = $(this);
        if ($target.hasClass('is-active')) {
            $target.removeClass('is-active');
        } else {
            $target.addClass('is-active');
        }
    });

    $(window).on('scroll', function() {
        var $element = $('.navbar-menu');

        if (window.pageYOffset > $element[0].offsetTop) {
            $element.addClass('sticky');
            $element.parent().addClass('is-sticky');
        } else {
            $element.removeClass('sticky');
            $element.parent().removeClass('is-sticky');
        }
    });

    $(document).mouseup(function (e) {
        const elements = $('.navbar-item.has-dropdown.is-active');

        $(elements).each(function() {
            if ( $(this).has(e.target).length === 0){
                $(this).removeClass('is-active');
            }
        });
    });
});
